import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Result from "./Result";
import Trial from "./Trial";
import MailError from "./MailError";
import ChiikiSearch from "./chiiki/ChiikiSearch";

export default function App() {
  const routes = [
    {
      path: "/trial/input",
      component: <Trial />,
    },
    {
      path: "/trial/mail-error",
      component: <MailError />,
    },
    {
      path: "/trial/result",
      component: <Result />,
    },
    {
      path: "/chiiki/search",
      component: <ChiikiSearch />,
    },
  ];

  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route, i) => (
          <Route path={route.path} element={route.component} key={i} />
        ))}
      </Routes>
    </BrowserRouter>
  );
}
